import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { MessageCircle } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const WhatsAppButton = () => {
  const [siteSettings, setSiteSettings] = useState(null);

  useEffect(() => {
    fetchSiteSettings();
  }, []);

  const fetchSiteSettings = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/cms/site-settings`);
      setSiteSettings(response.data);
    } catch (error) {
      console.error('Failed to fetch site settings:', error);
    }
  };

  const whatsappNumber = siteSettings?.whatsapp_number;
  
  if (!whatsappNumber) return null;

  const cleanNumber = whatsappNumber.replace(/[^0-9]/g, '');
  const whatsappUrl = `https://wa.me/${cleanNumber}?text=${encodeURIComponent('Hi! I have a question about your products.')}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] hover:bg-[#20BA5C] rounded-full shadow-lg flex items-center justify-center transition-all hover:scale-110 animate-pulse hover:animate-none"
      data-testid="whatsapp-button"
    >
      <MessageCircle className="w-7 h-7 text-white fill-white" />
    </a>
  );
};

export default WhatsAppButton;
